export default "__VITE_ASSET__c394cce1__"